<script>
const companyName = window.sessionStorage.getItem("浙江南华资本管理有限公司")
const system = window.sessionStorage.getItem("")         //生产环境填空或者填0, 其他环境填写字符串,'仿真环境', '测试环境'
const systemDescribe = window.sessionStorage.getItem("")         //环境描述


// const optionsQuoteServer = 'wss://biz.nanhuacapital.com/fdwsotccfg'        //现已弃用使用http请求替代

// const optionsQuoteServerMarket = "wss://biz.nanhuacapital.com/tq_201/ws/quote/underlying.do"     //用于前台报价界面行情接口
// const SpreadOptionsQuoteServerMarket = "wss://biz.nanhuacapital.com/tq_201/ws/quote/arbitrage.do"     //用于前台价差报价界面行情接口
// const underlyingMarketDataServe = optionsQuoteServerMarket    //用于远期行情
// const forwordTransactionServer = "wss://biz.nanhuacapital.com/t_201/ws/forward.do"    //用于远期推送委托交易持仓信息

// const baseURL = process.env.NODE_ENV === 'production' ? 'https://biz.nanhuacapital.com/t_201/':'http://localhost:8080/'      //分号问号后面第一个参数为升级时需要配置的环境


var optionsQuoteServerMarket = window.sessionStorage.getItem("optionsQuoteServerMarket")
var SpreadOptionsQuoteServerMarket = window.sessionStorage.getItem("SpreadOptionsQuoteServerMarket")
var underlyingMarketDataServe = window.sessionStorage.getItem("underlyingMarketDataServe")
var forwordTransactionServer = window.sessionStorage.getItem("forwordTransactionServer")

var baseURL = gainBaseUrl()

function gainBaseUrl() {
  let url = window.location.href
  url = url.split("#/")[0]
  return url
}

export default
{
  companyName,
  system,
  systemDescribe,
  optionsQuoteServerMarket,
  SpreadOptionsQuoteServerMarket,
  // optionsQuoteServer,
  underlyingMarketDataServe,
  forwordTransactionServer,
  baseURL,
}
</script>
